export default "__VITE_ASSET__DNZ50gLP__"